<!--
 * @Author: Gaho
 * @Date: 2023-12-18 17:34:01
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-06 10:15:33
 * @Description: 这是 jackpot 的规则说明窗口 
-->
<template>
    <q-dialog
        :modelValue="visible"
        @update:model-value="update"
        class="jackpot-dialog"
        scopeid='jackpot_u8vkmnkfj'
    >
        <q-card class="modal-card !max-h-full">
            <q-card-section class="row items-center q-pb-none mb-4 relative">
                <!-- modal 标题 -->
                <h2 class="modal-title">{{ `${game} Jackpot` }}</h2>
                <q-space />
                <p class="modal-close" @click.prevent="update">
                    <IconSvgUse use="icon-close" width="24" height="24" fill="#93acd3" />
                </p>
            </q-card-section>
            <!-- 
                ↑ 顶部标题
                ↓ 下方内容区 
            -->
            <q-card-section class="modal-content">
                <div class="content-header mb-4">
                    <p
                        v-if="currentJackpotData.img.text"
                        class="text-textFade text-xs mt-4 font-bold mb-4"
                    >
                        {{ $t(`jackpot.${currentJackpotData.img.text}`) }}
                        <span class="text-white">
                            {{ jackpotPercent?.jackpotStrike - jackpotPercent?.jackpotProgress }}
                        </span>
                    </p>
                    <img
                        v-if="game !== 'Circle' && currentJackpotData.img.src"
                        :src="currentJackpotData.img.src"
                    />
                    <!-- crash游戏进度条 -->
                    <div class="mt-[16px]"
                        v-if="game === 'Crash' && joinStore?.jackpotUser?.length"
                    >
                        <div
                            v-for="(item, index) in joinStore.jackpotUser.slice(0, 3)"
                            :key="index"
                            class="flex justify-between items-center mb-[14px] text-[12px] font-bold"
                        >
                            <span class="flex-1 truncate w-1/3">
                                {{ item.name }}
                            </span>
                            <span class="flex-1 mx-2 max-w-[70px]">
                                {{ (item.amount).toFixed(2) }}x
                            </span>
                            <span class="flex-[2]">
                                <!-- ↓ 这里的value 值为1表示进度 100% -->
                                <q-linear-progress
                                    rounded
                                    :value="item.progress * 0.01"
                                    size="4px"
                                    class="bg-[#343f5a]"
                                    color="green"
                                />
                            </span>
                        </div>
                    </div>
                    <!-- Circle进度条 -->
                    <q-linear-progress
                        v-if="game === 'Circle'"
                        rounded
                        :value="jackpotPercent?.jackpotProgress / jackpotPercent?.jackpotStrike"
                        size="8px"
                        class="q-mt-md bg-[#202a39]"
                        color="warning"
                    />
                    <div
                        v-if="currentJackpotData.img.info"
                        class="flex items-center justify-between mt-[16px] mb-[24px]"
                    >
                        <p
                            v-for="item in currentJackpotData.img.info"
                            :key="item"
                            class="info-item"
                        >
                            {{ item }}
                        </p>
                    </div>
                    <p class="text-textFade text-xs mt-4 font-medium mb-4">
                        {{ $t(`jackpot.${currentJackpotData.desc.text1}`) }}
                    </p>
                    <p
                        class="text-textFade text-xs mt-4 font-medium mb-4"
                        v-if="currentJackpotData.desc.text4"
                    >
                        {{ $t(`jackpot.${currentJackpotData.desc.text4}`) }}
                    </p>
                    <!-- Space Dice -->
                    <div v-if="currentJackpotData.desc.textInfo" class="mt-[16px] mb-[24px]">
                        <p
                            v-for="(item, index) in currentJackpotData.desc.textInfo"
                            :key="index"
                            class="text-[14px] font-[500]"
                        >
                            {{ $t(`jackpot.${item}`) }}
                        </p>
                    </div>
                </div>
                <!-- 
                    ↑ 按不同游戏显示区 
                    ↓ 通用区域
                -->
                <!-- Jackpot 百分比，通常有3个级别 --> 
                <div class="content-percent mb-4">
                    <JackpotPercent :jackpotPercentData="percentData" />
                </div>
                <div class="content-desc mb-4">
                    {{ $t(`jackpot.${currentJackpotData.desc.text2}`) }}
                </div>
                <div class="content-desc mb-4 mt-[-1rem]" v-if="currentJackpotData.desc.text3">
                    {{ $t(`jackpot.${currentJackpotData.desc.text3}`) }}
                </div>
                <!--
                    下方是大表格，最后的获奖者名单 
                -->
                <div class="content-table">
                    <JackpotTable :tableData="currentJackpotData.historyData" />
                </div>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script setup>
import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useJackPotSocket } from '@/socket/jackpot';

import JackpotPercent from './components/JackpotPercent.vue';
import JackpotTable from './components/JackpotTable.vue';
import { jackpotData } from './data';
import 'quasar/src/components/linear-progress/QLinearProgress.sass';
import 'quasar/src/components/space/QSpace.sass'; 

const props = defineProps({
    visible: {
        // 显示、隐藏
        type: Boolean,
        default: false,
    },
    update: {
        // toggle打开、关闭
        type: Function,
        default: () => {},
    },
    game: {
        // 游戏名称
        type: String,
        default: 'Plinko',
        required: true,
    },
});
const joinStore = useJoinStateStore();
const currentJackpotData = ref({});
const jackpotPercent = ref({})
const percentData = ref([]);

watch(
    () => props.visible,
    (newVal) => {
        if (!newVal) return;
        const { EMIT_JACKPOT_GETHISTORY, EMIT_GET_JACKPOT_CONFIG } = useJackPotSocket();
        currentJackpotData.value = jackpotData[props.game];
        // 获取中奖记录
        EMIT_JACKPOT_GETHISTORY(
            {
                id: joinStore.gameId,
            },
            (res) => {
                console.log(`${props.game} 游戏 jackpot ↓\n`, deepCopy(res.response)); 
                currentJackpotData.value.historyData = res.response;
            },
        );
        // 获取中奖分配比例数据
        EMIT_GET_JACKPOT_CONFIG(
            {
                game: props.game.toLocaleLowerCase().replace(' ', ''),
            },
            (res) => {
                console.log('EMIT_GET_JACKPOT_CONFIG', deepCopy(res));
                jackpotPercent.value = res;
                const arr = new Array(3).fill('');
                percentData.value = arr.map(
                    (item, index) => (arr[index] = res[`level${index + 1}`]),
                );
            },
        );
    },
    {
        immediate: true,
    },
);
</script>

<style lang="scss" scoped>
.modal-card {
    min-height: 62px;
    padding: 20px 24px;
    border-radius: 14px !important;
    background: #111923;
    max-width: 530px;

    &::before {
        background: linear-gradient(180deg, #003370, transparent);
        border-radius: 14px 14px 0 0;
        content: '';
        display: block;
        height: 72px;
        left: 0;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
    }

    :deep(.q-card__section--vert) {
        padding: 0;
    }

    .modal-title {
        font-size: 32px;
        font-weight: 700;
        line-height: 36px;
        text-transform: capitalize;
        color: #fff;
    }

    .q-icon {
        color: #fff;
        font-size: 14px;
    }

    .modal-close {
        color: #93acd3;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
        &:hover {
            color: #fff;
        }
    }

    .modal-content {
        color: #fff;

        .content-header {
            width: 100%;
        }
    }
    .info-item {
        align-items: center;
        background: #1bb83d;
        border-radius: 14px;
        display: flex;
        font-size: 24px;
        font-weight: 700;
        height: 56px;
        justify-content: center;
        letter-spacing: -0.02em;
        line-height: 32px;
        width: calc(25% - 4px);
    }
    .content-desc {
        color: #93acd3;
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
    }

    .content-table {
        :deep(.q-table__container) {
            background: #111923;
            color: white;

            .q-table__top {
                padding: 12px 0;

                .q-table__title {
                    font-size: 24px;
                    font-weight: 700;
                    letter-spacing: -0.02em;
                }
            }

            .q-table__middle {
                // height: 165px;
                max-height: 165px;
            }

            .no-data-message {
                width: 100%;
                text-align: center;
                color: #55657e;
                font-weight: 500;
                white-space: nowrap;
                font-size: 13px;
            }

            thead tr,
            th {
                height: 32px;
            }

            tbody tr,
            td {
                height: 44px;
            }

            tr {
                display: flex;
                width: 100%;
                align-items: center;
            }

            th {
                padding: 8px 0;
                color: #55657e;
                font-size: 11px;
                font-weight: 600;
                flex: 1;
                border-bottom: 1px solid #2a3546;
            }

            td {
                padding: 8px 0;
                font-size: 10px;
                font-weight: 500;
                line-height: 14px;
                white-space: pre-wrap;
                border-bottom: 1px solid #2a3546;
                flex: 1;
                overflow: hidden;
            }

            .td-date {
                font-size: 10px;
                font-weight: 500;
                line-height: 14px;
                white-space: pre-wrap;
            }

            .td-name {
                font-size: 12px;
                font-weight: 600;
                overflow-x: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                display: flex;
                align-items: center; 
            }

            .td-amount {
                font-weight: 600;
                letter-spacing: -0.5px;
                margin: auto 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                display: flex;
                align-items: center;
                cursor: pointer;

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 6px;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.jackpot-dialog[scopeid=jackpot_u8vkmnkfj] {
    z-index: 99;
    .q-dialog__inner {
        padding: 8px !important;
    }
}
</style>
